/** @format */

import { Link } from "react-router-dom";
import Header from "../../components/partials/dashboard/HeaderStyle/pub-header";
import backgroundImage from "src/assets/images/landing/fl-bg.jpeg";

const Index = () => {
  return (
    <div
      id="content-page"
      className="min-vh-100 d-flex flex-column"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Header />
      <div className="container-fluid d-flex flex-grow-1 justify-content-center align-items-center bg-black bg-opacity-25">
        <div className="row w-100">
          <div className="col-md-4 offset-md-1 d-flex flex-column justify-content-left align-items-left text-left">
            <h1 className="display-4 fw-bold text-white">
              Supercharge Your Professional Journey to Greatness
            </h1>
            <p className="mt-4 fs-5 text-white">
              Your ultimate career companion. Network with professionals,
              explore opportunities, and elevate your career effortlessly. Join
              now and transform your professional journey.
            </p>
            <Link
              className="btn btn-primary btn-lg mt-3"
              style={{ borderRadius: "50px", width: "150px" }}
              to="/auth/sign-in/user"
            >
              Sign In
            </Link>
            <p className="mt-4 fs-7 text-white">
              By clicking Continue to join or sign in, you agree to FirstLink
              User Agreement, Privacy Policy, and Cookie Policy. Test 1
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
